// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zRr1qFXSDPs5AtT6MMFc{align-items:center;gap:12px;padding:11.5px 0;display:flex}.h1Or6FpHVc0KqiM7pEGD{flex-direction:column;gap:4px;display:flex}.KDrjBHY5X6oeUscxXX5P{margin-left:auto}.ouT9zZO6P5wyXobieFTE{align-items:center;gap:4px;display:flex}.LNd1hSNbqwdvKbMWjmSf{margin-bottom:-12px;display:block}.iDfWlKiFFk4QvtbqFAAk{align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nameInfoContainer": `zRr1qFXSDPs5AtT6MMFc`,
	"nameContainer": `h1Or6FpHVc0KqiM7pEGD`,
	"ownerIcon": `KDrjBHY5X6oeUscxXX5P`,
	"numberContainer": `ouT9zZO6P5wyXobieFTE`,
	"modalTitle": `LNd1hSNbqwdvKbMWjmSf`,
	"row8": `iDfWlKiFFk4QvtbqFAAk`
};
export default ___CSS_LOADER_EXPORT___;
